import { IRespose } from '@/interface/response.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, catchError, lastValueFrom, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
    private API: string = `${environment.apiSimpleLaundry}`
  public user: any = null;

  constructor(private http: HttpClient) { }

  public getListar(ruta: string): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .get<IRespose<any>>(`${this.API}/${ruta}`)
      .pipe(
        catchError(this.handleError)
      ));
  }

  public getObtiene(ruta: string, id: any, postRuta: string = ""): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .get<IRespose<any>>(`${this.API}/${ruta}/${id}/${postRuta}`)
      .pipe(
        catchError(this.handleError)
      ));
  }

  public postCrear(ruta: string, request: any): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .post<IRespose<any>>(`${this.API}/${ruta}`, request)
      .pipe(
        catchError(this.handleError)
      ));
  }

  public putEdita(ruta: string, id: any, request: any): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .put<IRespose<any>>(`${this.API}/${ruta}/${id}`, request)
      .pipe(
        catchError(this.handleError)
      ));
  }

  public patchEdita(ruta: string, id: any, request: any): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .patch<IRespose<any>>(`${this.API}/${ruta}/${id}`, request)
      .pipe(
        catchError(this.handleError)
      ));
  }

  public delElimina(ruta: string, id: any): Promise<IRespose<any>> {
    return lastValueFrom(this.http
      .delete<IRespose<any>>(`${this.API}/${ruta}/${id}`)
      .pipe(
        catchError(this.handleError)
      ));
  }

  private handleError(e: any) {
    console.error('An error occurred', JSON.stringify(e)); // for demo purposes only
    return throwError(() => new Error(e.error.message));
  }
}
